import React, { Component } from 'react';
import Radium from 'radium';
import WMTextField from '@workmarket/front-end-components/dist/WMTextField';
import WMIconButton from '@workmarket/front-end-components/dist/WMIconButton';
import SearchIcon from 'material-ui/svg-icons/action/search';
import utils from '../utilities';
import translate from '../../funcs/translation';
import fetchRetry from "../../funcs/fetchRetry";

class SearchBar extends Component {
	constructor(props){
		super(props);
		this.state = {
			searchValue: "",
			displaySearch: false,
			hasNavBarSearchFeatureToggle: false,
		};
	}

	componentDidMount() {
		const fetchOptions = (options, token) => {
			return {
				credentials: 'same-origin',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json; charset=utf-8',
					Authorization: `Bearer ${token}`
				},
				body: JSON.stringify({ ...options })
			};
		};

		/* A feature toggle is used to determine which endpoint is used for the search bar */
		try {
			const navBarSearchSpaFT = 'nav_bar_search_spa';
			fetchRetry(
				'/v3/featuretoggle/get',
				fetchOptions({ featureNames: [navBarSearchSpaFT] }),
			)
				.then(response => response.json())
				.then(
					data => {
						const featureToggleResult = data.result.payload[0];
						const hasNavBarSearchFeatureToggle =
							featureToggleResult.name === `featuretoggle.${navBarSearchSpaFT}` && featureToggleResult.enabled;
						this.setState({ hasNavBarSearchFeatureToggle });
					},
					error => {
						console.error(error);
					},
				);
		} catch (error) {
			console.error('Attempt to fetch feature toggles failed:', error);
		}
	}

	updateSearchValue(el) {
		this.setState({searchValue: el.target.value});
	}

	searchAssignments() {
		if (this.state.hasNavBarSearchFeatureToggle) {
			window.location = `/manage?dashboardTable=%7B"keyword"%3A%5B"${this.state.searchValue}"%5D%7D`;
		} else {
			window.location = `/assignments/search?keyword=${encodeURIComponent(this.state.searchValue)}`;
		}
	}

	onSearchIconClick() {
		this.state.searchValue ?
			this.searchAssignments() :
			this.setState({displaySearch: !this.state.displaySearch });
	}

	render() {
		const styles = {
			outerDiv: {float: "left"}
		};
		utils.browser.isSmallMobile() ?
			styles.TextField =	{
				style: { fontFamily: 'Open Sans', color: '#ffffff', width: '152px' },
				inputStyle: {color: '#ffffff', boxShadow: 'none', width: '152px'},
				underlineFocusStyle:{ borderColor: '#ffffff', width: '152px'}
			} :
			styles.TextField = {
				style: {
					color: '#ffffff'
				},
				inputStyle: {color:'#ffffff', boxShadow: 'none' },
				underlineFocusStyle: { borderColor: '#ffffff'},
				hintStyle: {fontFamily: 'Open Sans', size: '14px', color: '#FBCA8E'}
			};

		return (
			<div style={styles.outerDiv}>
				<WMIconButton onClick={this.onSearchIconClick.bind(this)} >
					<SearchIcon color="#ffffff" />
				</WMIconButton>
				{this.state.displaySearch ?
					<WMTextField
						hintText={utils.browser.isSmallMobile()?translate("translation.search"):translate("translation.search_my_assignments")}
						onKeyDown={(e)=> e.keyCode === 13 && this.searchAssignments()}
						onChange={(e)=> this.updateSearchValue(e)}
						inputStyle={styles.TextField.inputStyle}
						style={styles.TextField.style}
						hintStyle={styles.TextField.hintStyle}
						value={this.state.searchValue}
						underlineFocusStyle={styles.TextField.underlineFocusStyle}/> :
						<span />
				}
			</div>
		);
	}
}

export default SearchBar = Radium(SearchBar);



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/SearchBar.jsx